export default "__VITE_ASSET__DaYFgpXi__"